import { render, staticRenderFns } from "./fullSceenTips.vue?vue&type=template&id=30997e91&scoped=true&"
import script from "./fullSceenTips.vue?vue&type=script&lang=js&"
export * from "./fullSceenTips.vue?vue&type=script&lang=js&"
import style0 from "./fullSceenTips.vue?vue&type=style&index=0&id=30997e91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30997e91",
  null
  
)

export default component.exports